import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import * as fromStore from '@ibe/store/index';


@Injectable({
	providedIn: 'root'
})
export class PayAncillariesWithMilesService {

	private ancillariesMiles = [
		{
			item: 'Seats',
			miles: 1800,
			promo: 18
		}, {
			item: 'Extra Bags',
			miles: 9000,
			promo: 20
		}, {
			item: 'Fast Track',
			miles: 8500,
			promo: 10
		}, {
			item: 'Lounge',
			miles: 8500,
			promo: 10
		}, {
			item: 'Sport Equipments',
			miles: 10000,
			promo: 30
		}, {
			item: 'Music Instruments',
			miles: 10500,
			promo: 30
		}, {
			item: 'Pets',
			miles: 9500,
			promo: 20
		}, {
			item: 'Special Meals',
			miles: 0,
			promo: 0
		}
	];

	//private ancillaryToPay: { name: string, count: number, total: number, active: boolean, id?: string };

	constructor(
		private store: Store<fromStore.State>
	) { }

	setAncillaryToPay(value) {
		this.store.dispatch(new AncillariesWithMilesActions.PutAncillaryToPayAction(value));
	}

	getMilesToPayAncillary(ancillaryToPay, promotype = 'miles'): Object {
		if (promotype === 'miles') {
			if (ancillaryToPay) {
				const miles = this.ancillariesMiles.find(item => item.item === ancillaryToPay.name).miles;
				ancillaryToPay = Object.assign({}, ancillaryToPay, { total: miles * ancillaryToPay.count });
			}
		} else {
			if (ancillaryToPay) {
				const miles = this.ancillariesMiles.find(item => item.item === ancillaryToPay.name).promo;
				ancillaryToPay = Object.assign({}, ancillaryToPay, { total: miles * ancillaryToPay.count });
			}
		}
		return ancillaryToPay;
	}
}
